import React from 'react';
import { createPortal } from 'react-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmDialog = ({ isOpen, onClose, files, onConfirm }) => {
  if (!isOpen || !files || files?.length === 0) return null;

  const fileCount = files?.length;
  const isSingle = fileCount === 1;

  return createPortal(
    <div className="modal-overlay animate-fade-in" onClick={onClose}>
      <div
        className="modal-content max-w-md animate-scale-in"
        onClick={(e) => e?.stopPropagation()}
      >
        <div className="modal-header">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-error/10 flex items-center justify-center">
              <Icon name="AlertTriangle" size={20} className="text-error" />
            </div>
            <h2 className="modal-title">Delete {isSingle ? 'File' : 'Files'}</h2>
          </div>
          <button onClick={onClose} className="focus-ring rounded-md p-1 hover:bg-muted">
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="modal-body">
          <p className="text-sm text-foreground mb-4">
            Are you sure you want to delete {isSingle ? 'this file' : `these ${fileCount} files`}?
            This action cannot be undone.
          </p>
          <div className="bg-muted rounded-md p-3 max-h-48 overflow-y-auto scrollbar-thin">
            {files?.map((file) => (
              <div key={file?.id} className="flex items-center gap-2 py-2">
                <Icon name="File" size={16} className="text-muted-foreground" />
                <span className="text-sm text-foreground truncate">{file?.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="modal-footer">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive" iconName="Trash2" iconPosition="left" onClick={onConfirm}>
            Delete {isSingle ? 'File' : 'Files'}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmDialog;